import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardText } from 'reactstrap';
import TextArrayField from '../../TextArrayField/TextArrayField';

const MailchimpFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="MailchimpFields">
            <Row>
                <Col>
                    <Card>
                    { ['newsletter', 'survey'].map(key => (
                        <CardBody key={key}>
                            <h5 className="IntegrationConfig-blockTitle">
                                { t(`settings.integrations.mailchimp.${key}`) }
                            </h5>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.api_key")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.api_key`} id="api_key" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.interest")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.interest`} id="interest" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.tags")}</Label>
                                            <Col lg={10} >
                                                <TextArrayField name={`integrations.mailchimp.${key}.tags`} id="tag" addTag={(v) => console.log(v)} />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.list_id")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.list_id`} id="list_id" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>

                            <h6 className="IntegrationConfig-blockSubtitle">{ t('settings.integrations.mailchimp.merge_fields.title') }</h6>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.merge_fields.city")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.merge_fields.city`} id="city" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.merge_fields.address")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.merge_fields.address`} id="address" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.merge_fields.country")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.merge_fields.country`} id="country" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.mailchimp.merge_fields.zip")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name={`integrations.mailchimp.${key}.merge_fields.zip`} id="zip" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    ))}
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default MailchimpFields;
